module.exports = __webpack_public_path__ + "img/balance-ico.2551b3b1.svg";